import React, { useMemo } from 'react';
import './OnboardingStepper.css';

export default function OnboardingStepper({ steps = [], activeStepId, completedStepIds = [] }) {
  const normalizedSteps = useMemo(() => (Array.isArray(steps) ? steps.filter(Boolean) : []), [steps]);
  const completed = useMemo(() => new Set(completedStepIds || []), [completedStepIds]);
  const activeIndex = useMemo(() => {
    if (normalizedSteps.length === 0) return 0;
    const idx = normalizedSteps.findIndex((step) => step.id === activeStepId);
    return idx >= 0 ? idx : 0;
  }, [normalizedSteps, activeStepId]);

  if (normalizedSteps.length <= 1) return null;

  const activeStep = normalizedSteps[activeIndex] || normalizedSteps[0];
  const progress =
    normalizedSteps.length <= 1
      ? 0
      : (activeIndex / (normalizedSteps.length - 1)) * 100;
  const progressPercent = `${Math.max(0, Math.min(100, Math.round(progress)))}%`;

  return (
    <nav
      className="onboarding-stepper"
      aria-label="Oppsettsteg"
      style={{ '--onboarding-stepper-progress': progressPercent }}
    >
      <div className="onboarding-stepper-top">
        <span className="onboarding-stepper-count">
          Steg {activeIndex + 1} av {normalizedSteps.length}
        </span>
        <span className="onboarding-stepper-active-label">{activeStep?.label || ''}</span>
      </div>
      <ol className="onboarding-stepper-track" aria-hidden="true">
        {normalizedSteps.map((step, index) => {
          const isActive = index === activeIndex;
          const isDone = completed.has(step.id) || index < activeIndex;
          return (
            <li
              key={step.id}
              className={`onboarding-stepper-dot${isActive ? ' is-active' : ''}${isDone ? ' is-done' : ''}`}
              title={step.label}
            >
              <span className="onboarding-stepper-dot-inner">
                {isDone ? '✓' : index + 1}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
